// DEFAULT
import React from "react";
import ReactDOM from "react-dom";

// APP
import App from "./App";

// CODE
ReactDOM.render(<App />, document.getElementById("root"));
